import { AfterViewInit, Component, OnInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

// RxJs
import { filter } from 'rxjs/operators';


// Root Singleton Services
import { RoutePartsService, ThemeService, UserPermissionsService } from 'app/core/services';
import { RouteService } from './auth/sessions/route.service';

@Component({
  selector: 'ebo-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, AfterViewInit {
  appTitle = 'EBO';
  pageTitle = '';
  isIframe = false;


  constructor(
    public title: Title,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private routePartsService: RoutePartsService,
    private themeService: ThemeService,
    private renderer: Renderer2,
    private permissionsService: UserPermissionsService,
    private routeService: RouteService
  ) {}

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;
    this.changePageTitle();
    this.loadPermissionsFromSession();
  }

  loadPermissionsFromSession(): void {
    const userObject = JSON.parse(sessionStorage.getItem('userObject'));
    if (userObject?.permissions) {
      this.permissionsService.setPermissions(userObject.permissions);
    } else {
      this.permissionsService.setPermissions([]);
    }
  }

  ngAfterViewInit() {
    this.themeService.applyMatTheme(this.renderer);
    // Restore the role-based colour instantly from the cache written on the
    // previous login — synchronous, no API call, no blink on reload.
    this.themeService.applyThemeFromCache();
  }

  smoothScrollToTop(element: HTMLElement, duration = 300) {
    const start = element.scrollTop;
    const startTime = performance.now();

    function scrollStep(timestamp: number) {
      const progress = Math.min((timestamp - startTime) / duration, 1);
      element.scrollTop = start * (1 - progress);
      if (progress < 1) {
        requestAnimationFrame(scrollStep);
      }
    }

    requestAnimationFrame(scrollStep);
  }

  changePageTitle() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(routeChange => {
      const container = document.querySelector('#main-content-wrap') as HTMLElement;
      if (container) {
        this.smoothScrollToTop(container, 400);
      }

      if (routeChange) {
        const getUrl = (routeChange as NavigationEnd).url;
        if (getUrl === '/sessions/signin') {
          sessionStorage.setItem(
            'appSettings',
            JSON.stringify({
              ...JSON.parse(sessionStorage.getItem('appSettings')),
              urlLoaded: '/test/dashboard/view'
            })
          );
          if (!sessionStorage.getItem('redirectUrl')) {
            this.routeService.storeCurrentUrl('/test/dashboard/view');
          }
        } else {
          sessionStorage.setItem(
            'appSettings',
            JSON.stringify({
              ...JSON.parse(sessionStorage.getItem('appSettings')),
              urlLoaded: getUrl
            })
          );
        }
      }

      if ((routeChange as NavigationEnd).url === '/redirect') return;
      const routeParts = this.routePartsService.generateRouteParts(this.activeRoute.snapshot);

      if (!routeParts.length) return this.title.setTitle(this.appTitle);
      // Extract title from parts;
      this.pageTitle = routeParts
        .reverse()
        .map(part => part.title)
        .reduce((partA, partI) => {
          return `${partA} > ${partI}`;
        });
      this.pageTitle += ` | ${this.appTitle}`;
      this.title.setTitle(this.pageTitle);
    });
  }
}
